<template>
  <div
    class="task-value"
    :class="{ 'task-value--miss': isEmptyValue, 'task-value--bad': isBadValue, 'task-value--good': isGoodValue }"
  >
    <v-tooltip v-if="hasInfo" top>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="task-value-info">
          <template v-if="isEntityParam">{{ data.value }}</template>
        </div>
      </template>

      <div v-for="(text, index) in data.list" :key="index">{{ text }}</div>
    </v-tooltip>

    <div v-else>
      <template v-if="isEntityParam">{{ data.value }}</template>
    </div>
  </div>
</template>

<script>
import { EntityParamValue } from "@/modules/tasks/task-value/entities/EntityParamValue.js";
import { EntitySymptomValue } from "@/modules/tasks/task-value/entities/EntitySymptomValue.js";
import { EntityReminderValue } from "@/modules/tasks/task-value/entities/EntityReminderValue.js";

export default {
  name: "TaskValue",

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasInfo() {
      return this.data.list.length > 0;
    },

    isEmptyValue() {
      return this.data.eventsCount && !this.data.value;
    },

    isEntityParam() {
      return this.data instanceof EntityParamValue;
    },

    isEntitySymptom() {
      return this.data instanceof EntitySymptomValue;
    },

    isEntityReminder() {
      return this.data instanceof EntityReminderValue;
    },

    isBadValue() {
      if (this.isEntitySymptom && this.data.value !== null) {
        return this.data.eventsCount > this.data.value.count;
      }

      if (this.isEntityReminder && this.data.value !== null) {
        return this.data.eventsCount > this.data.value.count;
      }

      return false;
    },

    isGoodValue() {
      if (this.isEntitySymptom && this.data.value !== null) {
        return (this.data.eventsCount === 0 && this.data.value.count > 0) || this.data.eventsCount === this.data.value.count;
      }

      if (this.isEntityReminder && this.data.value !== null) {
        return this.data.eventsCount === this.data.value.count;
      }

      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.task-value {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.task-value-info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.task-value--bad {
  background-color: #ffa5005c;
}

.task-value--good {
  background-color: mediumseagreen;
}

.task-value--miss {
  background-color: #fef0f0;
}
</style>
